import $axios from '../services/api.js'

const state = () => ({
    announcements_total: 0,
    announcements_total_pages: 0,
    announcements: [],
})

const mutations = {
    ASSIGN_TOTAL_ANNOUNCEMENTS(state, payload) {
        state.announcements_total = payload
    },
    ASSIGN_TOTAL_PAGE_ANNOUNCEMENTS(state, payload) {
        state.announcements_total_pages = payload
    },
    ASSIGN_ANNOUNCEMENTS_INITIAL(state, payload) {
        state.announcements = payload
    },
    ASSIGN_ANNOUNCEMENTS(state, payload) {
        state.announcements = state.announcements.concat(payload)
    },
}

const actions = {
    getAnnouncementsCount({ commit }) {
        return new Promise((resolve) => {
            $axios.get(`/pengumuman?per_page=1`)
                .then((response) => {
                    commit('ASSIGN_TOTAL_ANNOUNCEMENTS', response.headers['x-wp-total'])
                    resolve(response)
                })
        })
    },
    getAnnouncements({ commit }) {
        return new Promise((resolve) => {
            $axios.get(`/pengumuman?per_page=5`)
                .then((response) => {
                    commit('ASSIGN_TOTAL_PAGE_ANNOUNCEMENTS', response.headers['x-wp-totalpages'])
                    commit('ASSIGN_ANNOUNCEMENTS_INITIAL', response.data)
                    resolve(response)
                })
        })
    },
    getAnnouncementsLoadMore({ commit }, nextPage) {
        return new Promise((resolve) => {
            $axios.get(`/pengumuman?_embed&per_page=5&page=${nextPage}`)
                .then((response) => {
                    commit('ASSIGN_ANNOUNCEMENTS', response.data)
                    resolve(response)
                })
        })
    },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}